module.exports = __webpack_public_path__ + "img/individual.0ae3f9e2.svg";